import { TrackableEvent } from './types/TrackableEvent';
import * as amplitude from '@amplitude/analytics-browser';
import mixpanel from 'mixpanel-browser';

export const trackRawEvent = (e: TrackableEvent): void => {
  amplitude.track(e.event.toString(), e.props);
  mixpanel.track(e.event.toString(), e.props);
};
